export const jarvisPrimeTransactionConstants = {
  PRIME_RESET_TRANSACTION_DATA: "PRIME_RESET_TRANSACTION_DATA",
  PRIME_TRANSACTION_LIST_SAGA: "PRIME_TRANSACTION_LIST_SAGA",
  PRIME_TRANSACTION_LIST_REQUEST: "PRIME_TRANSACTION_LIST_REQUEST",
  PRIME_TRANSACTION_LIST_RESPONSE: "PRIME_TRANSACTION_LIST_RESPONSE",
  PRIME_TRANSACTION_LIST_API: "prime/portfolio/purchase",
};
